import { toast } from "react-hot-toast";
import React from "react";
import { createRoot } from "react-dom/client";
import { AlertModal } from "../../components/Modals/AlertModal";
import OverlayLoading from "../../components/Loading/OverlayLoading";
import { scheduleModalCleanup } from "./modalLifecycle";
import PATH_URL from "../../routers/path";
import { getReadableApiError } from "./apiError";

export const showAlert = ({ message, type = "success", isPrint = false, printUrl = "" }) => {
  const div = document.createElement("div");
  document.body.appendChild(div);

  const root = createRoot(div);

  const close = () => {
    root.unmount();
    div.remove();
    scheduleModalCleanup({ delay: 0 });
  };

  const handlePrint = () => {
    window.open(printUrl, "_blank", "noopener,noreferrer");
    close();
  };

  root.render(<AlertModal message={message} type={type} onClose={close} isPrint={isPrint} handlePrint={handlePrint} />);
  return close;
};

export const showAlertPrint = ({ message, type = "success", id }) =>
  showAlert({
    message,
    type,
    isPrint: true,
    printUrl: PATH_URL.TESTING_PRINT_INVOICE.replace(":id", id),
  });

export const showLoading = (isShow = true) => {
  if (!isShow) return () => {};

  const div = document.createElement("div");
  document.body.appendChild(div);

  const root = createRoot(div);

  const close = () => {
    root.unmount();
    div.remove();
    scheduleModalCleanup({ delay: 0 });
  };

  root.render(<OverlayLoading isShow={isShow} />);
  return close;
};

export const showToast = (promise, messages = {}) => {
  const originalError = messages.error;
  const readableMessages = {
    ...messages,
    error: (error) => {
      const fallback = typeof originalError === "function" ? originalError(error) : originalError;
      return getReadableApiError(error, fallback);
    },
  };

  return toast.promise(promise, readableMessages, {
    position: "top-right",
    duration: 2500,
    style: {
      borderRadius: "8px",
      background: "#fff",
      color: "#333",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
      fontSize: "1rem",
    },
    loading: {
      duration: 1500,
      style: {
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        background: "#fff",
        fontSize: "1rem",
      },
    },
    success: {
      duration: 2000,
      style: {
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
        background: "#fff",
        color: "#059669",
        fontSize: "1rem",
        fontWeight: "bold",
        padding: "1rem",
        borderRadius: "8px",
      },
    },
    error: {
      duration: 5500,
      style: {
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        background: "#fff",
        color: "rgba(239, 68, 68)",
        fontSize: "0.925rem",
        fontWeight: "600",
        lineHeight: "1.45",
        maxWidth: "32rem",
        padding: "1rem",
        borderRadius: "8px",
      },
    },
  });
};
